export default __webpack_public_path__ + "static/media/answer4.75fe3634.png";